/* eslint-disable react-refresh/only-export-components */
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { FC, StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { queryClient } from './app/lib/query-client';
import { router } from './app/lib/router.js';
import { AuthProvider } from './entity/auth/auth-provider';
import * as Sentry from '@sentry/react';

Sentry.init({
    dsn: 'https://5152965a39dad2ecd7109228613e05c7@o4509272108367872.ingest.de.sentry.io/4509272109613136',
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ['localhost'],
    environment: 'production',
});

const RouterProviderWithContext: FC = () => {
    return <RouterProvider router={router} />;
};

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <QueryClientProvider client={queryClient}>
            <AuthProvider>
                <RouterProviderWithContext />
            </AuthProvider>
        </QueryClientProvider>
    </StrictMode>,
);
